import React from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { useFormState } from '../../../context';
import classNames from 'classnames';
import { CANCELLATION_REASONS } from '../../../constants';

function ReasonSelection({ name = 'cancellationReason' }) {
  // Get form state and handlers from context
  const { selectedReason, handleReasonChange, otherReasonText, handleOtherReasonChange } = useFormState();
  return (
    <div className="wlc-cancel-reason-selection-content">
      <h5>Let’s make sure you get what you need before you go.</h5>
      <p>What’s the main reason you’re thinking of canceling your WHOLE Life Club membership today?</p>
      <p className="mb-0">
        <em>Please select the option that fits best:</em>
      </p>
      <Form>
        {CANCELLATION_REASONS.map(option => (
          <div key={option.value}>
            <FormGroup
              check
              className={classNames({
                'reason-other': option.value === 'other',
                'reason-selected': selectedReason === option.value
              })}
            >
              <Label check>
                <Input
                  type="radio"
                  name={name}
                  value={option.value}
                  checked={selectedReason === option.value}
                  onChange={handleReasonChange}
                />
                &nbsp;{option.label}
              </Label>
            </FormGroup>
            {option.value === 'other' && selectedReason === 'other' && (
              <FormGroup className="reason-other-textarea">
                <Input
                  type="textarea"
                  name={`${name}Other`}
                  placeholder="Please specify your reason..."
                  value={otherReasonText || ''}
                  onChange={handleOtherReasonChange}
                  rows="3"
                />
              </FormGroup>
            )}
          </div>
        ))}
      </Form>
    </div>
  );
}

export default ReasonSelection;
